import { createAdminMode, useAdminMode as useSharedAdminMode, useSession, type AdminModeState } from "@jkast90/kast-common/auth";
import { ADMIN_GROUPS } from "../auth/session";

// Admin tools are opt-in (kast-common's admin mode): the admin groups only
// offer the "Admin tools" switch (About, Preferences), and the Admin link
// and the admin-only bits elsewhere show only while it is on. It starts off,
// so an admin uses CloudBoy as a player by default. The stored switch never
// grants on its own: without the group it does nothing. Groups match
// exactly, as Cognito has them (play-api ignores case; no differently-cased
// group exists).
//
// This only decides what to show. play-api checks the group on every admin
// route, so the switch is a safety catch against stray taps, not a boundary.
// It stays on this device; it isn't one of the settings that follow the account.
export const ADMIN_MODE_KEY = "pocket-play.adminMode";

/** The switch. `adminMode.isOn(user)` for code outside React (the crash screen). */
export const adminMode = createAdminMode({ admin: ADMIN_GROUPS, storageKey: ADMIN_MODE_KEY });

/** Admin mode for the signed-in account. */
export function useAdminMode(): AdminModeState {
  return useSharedAdminMode(adminMode, useSession());
}
